import { Project } from "../types/project";
// Project {
//     title: string,
//     description: string,
//     startDate: Date | string,
//     endDate: Date | string,
//     imageURL: string,
//     linkURL: string,
//     tags: string[]
// }
export const projects:Project[] = [
    {
        title: "Jitsmapper",
        description: "A mind mapping tool for grapplers.",
        startDate: "2014/06/24",
        endDate: "2014/06/24",
        imageURL: "/assets/jitsmapper_screenshot.png",
        linkURL: "http://167.71.145.90:8888/",
        tags: ["AngularJS", "Django", "JIT"],
        category: "personal"
    },
    {
        title: "Eight Bit Beats",
        description: "Collaborative real-time beat sequencer.",
        startDate: "2012/06/24",
        endDate: "2012/06/24",
        imageURL: "/assets/8bb_screenshot.png",
        linkURL: "http://167.71.145.90:7777",
        tags: ["Node Knockout Winner", "backbone.js", "node.js", "express.js", "websockets", "WebAudio"],
        category: "personal"
    },
    {
        title: "Disasteroids",
        description: "Gravity-based orbital multiplayer shooter.",
        startDate: "2013/06/24",
        endDate: "2013/06/24",
        imageURL: "/assets/disasteroids_screenshot.png",
        linkURL: "http://167.71.145.90:8087",
        tags: ["Node Knockout Winner", "backbone.js", "node.js", "express.js", "websockets"],
        category: "personal"
    },
    {
        title: "Hawaiian Airlines",
        description: "Rebuilt booking system and responsive UI in AngularJS. A/B testing.",
        startDate: "2014/06/24",
        endDate: "",
        imageURL: "/assets/ha_screenshot.png",
        linkURL: "https://hawaiianairlines.com",
        tags: ["AngularJS", "less.css"],
        category: "professional"
    },
    {
        title: "Transwest Trucking",
        description: "Custom JS solution for searching, sorting, and filtering Transwest products.",
        startDate: "2013/02/06",
        endDate: "2013/04/17",
        imageURL: "/assets/transwest_screenshot.png",
        linkURL: "https://transwest.com",
        tags: ["JavaScript"],
        category: "professional"
    },
    {
        title: "SimpleEnergy",
        description: "Built Admin UI in Ember.js. Migrated from PHP backend to Django.",
        startDate: "2013/04/18",
        endDate: "2014/03/04",
        imageURL: "/assets/se_screenshot.png",
        linkURL: "http://simpleenergy.com",
        tags: ["ember.js", "PHP", "Django"],
        category: "professional"
    },
]